import React, { useState } from 'react';
import Input from '../form/Input';
import { useQueryString } from '../../pages/titleManagement/AudiobookDetail';
import { useHistory, useLocation } from 'react-router-dom';
import { useLocalStorage } from 'react-use';

function SearchBar() {
    const location = useLocation();
    const history = useHistory();
    const query = useQueryString(location.search);
    const term = query.get('q');
    const [searchTerm, setSearchTerm] = useState(term ?? '');
    const [previousSearches, setPreviousSearches] = useLocalStorage('previousSearches', []);

    const handleSubmit = (event) => {
        event.preventDefault();
        const safeTerm = encodeURIComponent(searchTerm);
        history.push(`/search?q=${safeTerm}`);
        setPreviousSearches([...new Set([searchTerm, ...previousSearches.slice(0, 7)])]);
    };

    React.useEffect(() => {
        let newValue = '';
        setSearchTerm(newValue);
    }, [term, location]);

    return (
        <form onSubmit={handleSubmit}>
            <div className="searchBar">
                <Input
                    label="Search Cube"
                    placeholder="Search Book URI, Content ID, ISBN, Title, Author, etc"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    append={
                        <button className="btn btn-primary" type="submit">
                            Search
                        </button>
                    }
                    hideLabel
                    collapse
                />
            </div>
        </form>
    );
}

export default SearchBar;
